module.exports = __webpack_public_path__ + "static/media/GEO-3.a3e4e138.png";